import React, { useState } from 'react';

const CarouselBlock = ({ block }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const images = block.content || [];

    const prevSlide = (e) => {
        e.stopPropagation();
        setCurrentIndex(currentIndex === 0 ? images.length - 1 : currentIndex - 1);
    };

    const nextSlide = (e) => {
        e.stopPropagation();
        setCurrentIndex(currentIndex === images.length - 1 ? 0 : currentIndex + 1);
    };

    if (images.length === 0) {
        return (
            <div className="w-full h-48 bg-gray-200 flex items-center justify-center text-gray-500">
                Carrousel vide
            </div>
        );
    }

    return (
        <div className="relative w-full h-48">
            <img src={images[currentIndex]} alt={`Slide ${currentIndex}`} className="w-full h-full object-cover" />
            {images.length > 1 && (
                <>
                    <button onClick={prevSlide} className="absolute top-1/2 left-2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full">‹</button>
                    <button onClick={nextSlide} className="absolute top-1/2 right-2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full">›</button>
                </>
            )}
        </div>
    );
};

export default CarouselBlock;